const Actions = {
  OPEN: 'aev.modal.actions.open',
  CLOSE: 'aev.modal.actions.close'
};

const Mutations = {
  OPEN: 'aev.modal.mutations.open',
  CLOSE: 'aev.modal.mutations.close'
};

export default {
  Actions,
  Mutations
};
